import { IMEvent, ErrorType } from '../consts.js';
import { Logger } from '../metrics/logger.js';
import { MonitorItem } from '../metrics/monitor.js';
import { ServiceIdentity } from '../service/RuntimeContext.js';

/** 基本错误类型 */
class BaseError extends Error {
    /** @internal */
    constructor(param) {
        var _a, _b, _c, _d;
        super(`${param && param.logid ? `[${param.logid}] ` : ''}${param && param.msg ? 'message: "' + param.msg + '"' : ''}${param && param.innerError ? `, inner error: "${param.innerError}"` : ''}`);
        this.ctx = param.ctx;
        Object.assign(this, param);
        Object.setPrototypeOf(this, BaseError.prototype);
        if ((_a = this.innerError) === null || _a === void 0 ? void 0 : _a.logid) {
            this.logid = this.innerError.logid;
        }
        // 嵌套多层error时, 尝试拼接完整的堆栈
        try {
            if (typeof ((_b = this.innerError) === null || _b === void 0 ? void 0 : _b.stack) === 'string') {
                this.stack = this.innerError.stack + '\n' + ((_c = this.stack) === null || _c === void 0 ? void 0 : _c.split('\n').slice(2).join('\n'));
            }
        }
        catch (err) {
            Logger.ctxWarn(this.ctx, `concat trace fail=${err}, current stack=${this.stack}, inner stack=${(_d = this.innerError) === null || _d === void 0 ? void 0 : _d.stack}`);
        }
        if (!this.ctx) {
            return;
        }
        if (!param.ignoreEvent) {
            this.resolve(ServiceIdentity.EventBus).emit(IMEvent.Error, param.sender, this);
        }
        this.resolve(ServiceIdentity.Monitor).emitError(this);
        this.resolve(ServiceIdentity.Monitor).emitCounter(MonitorItem.BizSdkError, 1, {
            type: param.type ? `${param.type}:${ErrorType[param.type]}` : 'unknown'
        });
    }
    getContext() {
        return this.ctx;
    }
    resolve(identity) {
        return this.ctx.resolve(identity);
    }
}

export { BaseError };
//# sourceMappingURL=BaseError.js.map
